import { tr as reacttr } from '@ews/react-translations';

const tr = {
...reacttr
}
export default tr
